import mediumZoom from 'medium-zoom';
import { SELECTORS } from './constants';

function setupImageLightBox() {
  mediumZoom(SELECTORS.zoomable_images, {
    background: 'rgba(255, 255, 255, 0.8)',
  });
}

export { setupImageLightBox };
